namespace Areas {
    "use strict";

    //export function gotoContract(id: string) {
    //    gotoSelected("ContractGrid", "/Contract/GeneralInfo/View/");
    //}

    //export function gotoProject(e: any, fieldName: string, objectName: string, isGrid: boolean, isOption: boolean) {
    //    clearSelectBoxSelection(e);
    //    let linkInfo = "/Project/Profile/View/" + id;

    //    if (isGrid == true)
    //    {
    //        gotoSelectedOnGrid(objectName,)
    //    }

    //    gotoSelected("ContractGrid", "/Contract/GeneralInfo/View/");
    //}

    //export function gotoCostCenter(id: string) {
    //    gotoSelected("ContractGrid", "/Contract/GeneralInfo/View/");
    //}

    export function goToSharePoint(e: any) {
        const id = e.component.option("SharePointLink");
        let linkInfo = "https://sharepoint.capnet.ucla.edu/sites/ActiveProjects/" + id + "/default.aspx";
        window.open(linkInfo);
    }

    export function goToPIFPAF(e: any) {
        const id = e.component.option("ProjectId");
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + id + "";
        window.open(linkInfo);
    }

    export function goToProject(e: any) {
        const id = e.component.option("AccountId");
        let linkInfo = "/Account/Profile/View/" + id;
        window.open(linkInfo);
    }


    export function websiteSharePoint(sharePointLink: string) {
        var returnLink = "https://sharepoint.capnet.ucla.edu/sites/ActiveProjects/default.aspx";
        if (isNotEmpty(sharePointLink)) {
            returnLink = "https://sharepoint.capnet.ucla.edu/sites/ActiveProjects/" +
                sharePointLink + "/Documents/7-%20Construction%20Management";
        }
        window.open(returnLink);
    }

    export function gotoSelectedOnForm(formName: string, url: string) {
        const dataForm = $(`#${formName}`).dxForm("instance");
        const dataId = dataForm.option()[0];
        if (dataId != null) {
            location.href = url + dataId;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

}